import { render, staticRenderFns } from "./Lgx319175813431820288.vue?vue&type=template&id=1f348843&scoped=true&"
import script from "./Lgx319175813431820288.vue?vue&type=script&lang=js&"
export * from "./Lgx319175813431820288.vue?vue&type=script&lang=js&"
import style0 from "./Lgx319175813431820288.vue?vue&type=style&index=0&id=1f348843&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f348843",
  null
  
)

export default component.exports